"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkFactories = exports.getFactoryByAddress = exports.IMPERMAX_FACTORY = void 0;
const types_1 = require("../types");
exports.IMPERMAX_FACTORY = {
    [types_1.Networks.Ropsten]: {},
    [types_1.Networks.Mainnet]: {
        [types_1.Factory.V2V1]: '0x8C3736e2FE63cc2cD89Ee228D9dBcAb6CE5B767B'
    },
    [types_1.Networks.Polygon]: {
        [types_1.Factory.V2V1_1]: '0xBB92270716C8c424849F17cCc12F4F24AD4064D6',
        [types_1.Factory.V2V2]: '0x7F7AD5b16c97Aa9C2B0447C2676ce7D5CEFEbCd3',
        [types_1.Factory.SOLV2]: '0x7ED6eF7419cD9C00693d7A4F81c2a151F49c7aC2',
        [types_1.Factory.SOL_STABLE]: '0x60f57cF15a34fA0Aa25eF37eB827E1a0948966c5',
    },
    [types_1.Networks.Arbitrum]: {
        [types_1.Factory.V2V1_1]: '0x8C3736e2FE63cc2cD89Ee228D9dBcAb6CE5B767B',
        [types_1.Factory.V2V2]: '0x9708e0b216a88d38d469b255ce78c1369ad898e6',
        [types_1.Factory.SOLV2]: '0x97bc7fefb84a4654d4d3938751b5fe401e8771c2',
    },
    [types_1.Networks.Avalanche]: {
        [types_1.Factory.V2V1_2]: '0x8C3736e2FE63cc2cD89Ee228D9dBcAb6CE5B767B',
        [types_1.Factory.V2V2]: '0x9708e0b216a88d38d469b255ce78c1369ad898e6',
        [types_1.Factory.SOLV2]: '0xc7f24fd6329738320883ba429C6C8133e6492739',
    },
    [types_1.Networks.Moonriver]: {
        [types_1.Factory.V2V1_2]: '0x8C3736e2FE63cc2cD89Ee228D9dBcAb6CE5B767B',
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [types_1.Factory.SOLV1_2]: '0x60aE5F446AE1575534A5F234D6EC743215624556',
        [types_1.Factory.SOLV2]: '0x9b4ae930255CB8695a9F525dA414F80C4C7a945B',
        [types_1.Factory.V2V2]: '0x1E6B86C09fdBe02fEB228A585C487623Fc395D34'
    },
    [types_1.Networks.Canto]: {
        [types_1.Factory.SOLV2]: '0x9708E0B216a88D38d469B255cE78c1369ad898e6',
    },
    [types_1.Networks.ZksyncEra]: {
        [types_1.Factory.SOLV2]: '0x6ce1a2C079871e4d4b91Ff29E7D2acbD42b46E36',
    },
    [types_1.Networks.Blast]: {
        [types_1.Factory.SOLV2]: '0x7B816c1CCaFA7D3e71E279Ed9DC3226484f6EF87',
        [types_1.Factory.V2V2]: '0xb3C80CFcdD177E3FCe2E66870E4768d1EAd89F6c',
        [types_1.Factory.SOL_STABLE]: '0xfff3C004D115002E0fe8Ef08bBB127aEF5B97bE1',
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [types_1.Factory.SOLV2]: '0x66ca66E002a9CEE8dEfE25dB6f0c6225117C2d9f',
        [types_1.Factory.SOL_STABLE]: '0x8aDc5F73e63b3Af3fd0648281fE451738D8B9D86',
        [types_1.Factory.V2V2]: '0x47183bB55AD0F891887E099Cec3570d3C667cD00',
    },
    [types_1.Networks.Scroll]: {
        [types_1.Factory.SOLV2]: '0x02Ff7B4d96EeBF8c9B34Fae0418E591e11da3099',
        [types_1.Factory.SOL_STABLE]: '0xFBD17F3AA7d6506601D2bF7e15a6C96081296a01',
    },
    [types_1.Networks.Real]: {
        [types_1.Factory.SOLV2]: '0x2944e1544cE201ae19e6385490bBA13DaA5f44e4',
        [types_1.Factory.SOL_STABLE]: '0x3B1f3a48A70e372144307A4b126A5cDA46E169AD',
    },
    [types_1.Networks.Mantle]: {
        [types_1.Factory.V2V2]: '0x3047523D5ed0df1545B1C440BdAaB095f1f3cf5C'
    },
    [types_1.Networks.Optimism]: {
        [types_1.Factory.SOLV2]: '0xa058Ba91958cD30D44c7B0Cf58A369876Fb70B05',
    },
    [types_1.Networks.Sonic]: {
        [types_1.Factory.SOLV2]: '0x26fca5916c20D252feEF7A58E39886d3d3112b91',
        [types_1.Factory.SOL_STABLE]: '0x6e1E988D828D0102BF93434774cd1a2246062564',
    },
    [types_1.Networks.Linea]: {
        [types_1.Factory.SOLV2]: '0x7A9212D34DD283e952f8f15f084832e9b48ee746',
        [types_1.Factory.SOL_STABLE]: '0x0D5433FEe91fb2DB9dd6A74267Dd900EC2130675'
    },
};
function getFactoryByAddress(network, address) {
    if (!address)
        return null;
    for (const factory of Object.keys(exports.IMPERMAX_FACTORY[network])) {
        const factoryAddress = exports.IMPERMAX_FACTORY[network][factory];
        if (factoryAddress &&
            address.toLowerCase() == factoryAddress.toLowerCase())
            return factory;
    }
    return null;
}
exports.getFactoryByAddress = getFactoryByAddress;
function getNetworkFactories(network) {
    const networkConfig = exports.IMPERMAX_FACTORY[network];
    if (!networkConfig)
        return [];
    return Object.values(networkConfig).map(factory => factory.toLowerCase());
}
exports.getNetworkFactories = getNetworkFactories;
